"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));
var _Popover = _interopRequireDefault(require("@airasia/phoenix-components/components/Popover"));
var _PriceBreakDown = _interopRequireDefault(require("@airasia/phoenix-components/components/PriceBreakDown"));
var _Price = _interopRequireDefault(require("@airasia/phoenix-components/components/Price"));
var _RoomCard = require("../RoomCard/RoomCard.propTypes");
var _BigPointToBeEarned = _interopRequireDefault(require("@airasia/phoenix-components/components/BigPointToBeEarned"));
var _Utils = require("./Utils");
var _constants = require("./constants");
var _BogoInfoIcon = _interopRequireDefault(require("../HotelCard/BogoInfoIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PriceWrapper",
  componentId: "sc-1i7dnbo-0"
})(["display:", ";padding:", ";position:", ";", " vertical-align:bottom;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return !isMobile ? 'flex' : 'flex';
}, function (_ref2) {
  var theme = _ref2.theme,
    isMobile = _ref2.isMobile;
  return !isMobile ? theme.space.small : 0;
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return !isMobile ? 'relative' : '';
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? 'align-items: flex-end; width: 100%;' : '';
});
var PriceDetails = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PriceDetails",
  componentId: "sc-1i7dnbo-1"
})(["text-align:right;width:100%;"]);
var StrikeThrough = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__StrikeThrough",
  componentId: "sc-1i7dnbo-2"
})(["font-size:", ";line-height:", ";text-decoration-line:line-through;color:", ";mix-blend-mode:normal;float:", ";margin-left:auto;margin-top:", ";margin-right:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize.XSmall;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.lineHeight.XXSmall;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.greyDark;
}, function (_ref8) {
  var isMobile = _ref8.isMobile;
  return !isMobile ? 'left' : '';
}, function (_ref9) {
  var isMobile = _ref9.isMobile;
  return isMobile ? '10px' : '3px';
}, function (_ref10) {
  var isMobile = _ref10.isMobile,
    isBogoPromoEnabled = _ref10.isBogoPromoEnabled;
  return !isMobile ? '3px' : !isBogoPromoEnabled && '93px';
});
var BasePriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__BasePriceWrapper",
  componentId: "sc-1i7dnbo-3"
})(["font-size:", ";line-height:", ";color:", ";margin-top:", ";margin-bottom:", ";font-weight:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSize.medium;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.lineHeight.small;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.greyDarker;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.tiny;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.tiny;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontWeight.medium;
});
var TotalPrice = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__TotalPrice",
  componentId: "sc-1i7dnbo-4"
})(["font-size:", ";line-height:", ";color:", ";margin-top:", ";margin-left:auto;margin-bottom:", ";font-weight:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontSize.medium;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.lineHeight.small;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.neutral;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.tiny;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.space.tiny;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.fontWeight.medium;
});
var PriceMobile = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PriceMobile",
  componentId: "sc-1i7dnbo-5"
})(["font-size:", ";color:", ";margin-bottom:8px;font-weight:", ";"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.fontSize.medium;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.neutral;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontWeight.medium;
});
var BaseValue = _styledComponents.default.span.withConfig({
  displayName: "PriceInfo__BaseValue",
  componentId: "sc-1i7dnbo-6"
})(["font-weight:", ";font-size:20px;color:", ";"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.fontWeight.medium;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.greyDarker;
});
var TotalValue = _styledComponents.default.span.withConfig({
  displayName: "PriceInfo__TotalValue",
  componentId: "sc-1i7dnbo-7"
})(["font-weight:", ";font-size:", ";font-family:", ";color:", ";"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.fontWeight.medium;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.fontSize.normal;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.fontFamily.default;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.colors.greyDark;
});
var ParentContainer = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ParentContainer",
  componentId: "sc-1i7dnbo-8"
})(["display:flex;justify-content:flex-end;align-items:center;width:100%;"]);
var SummaryPaxWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__SummaryPaxWrapper",
  componentId: "sc-1i7dnbo-9"
})(["font-size:12px;font-weight:400;color:#75767a;max-width:200px;white-space:normal;word-wrap:break-word;text-align:right;margin-bottom:10px;"]);
var DiscountPercent = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__DiscountPercent",
  componentId: "sc-1i7dnbo-10"
})(["background-color:", ";color:", ";font-size:", ";font-weight:", ";line-height:", ";padding-right:", ";padding-left:", ";border-radius:", ";", " display:flex;justify-content:flex-end;align-items:right;float:right;"], function (_ref32) {
  var theme = _ref32.theme;
  return theme.backgroundColor.greenLight;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.colors.tertiary;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.fontSize.XSmall;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.fontWeight.medium;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.lineHeight.small;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.space.micro;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.space.micro;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.borderRadius.normal;
}, function (_ref40) {
  var isMobile = _ref40.isMobile;
  return isMobile ? 'display: inline-block; margin-bottom: 6px' : '';
});
var GuestInfo = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__GuestInfo",
  componentId: "sc-1i7dnbo-11"
})(["font-style:normal;font-weight:", ";align-items:right;font-size:10px;line-height:", ";text-align:right;color:", ";mix-blend-mode:normal;"], function (_ref41) {
  var theme = _ref41.theme;
  return theme.fontWeight.medium;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.lineHeight.XSmall;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.colors.neutral;
});
var Includes = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__Includes",
  componentId: "sc-1i7dnbo-12"
})(["font-style:normal;font-weight:normal;font-size:10px;line-height:150%;align-items:right;text-align:right;color:", ";mix-blend-mode:normal;padding-bottom:", ";"], function (_ref44) {
  var theme = _ref44.theme;
  return theme.colors.greyDark;
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.space.tiny;
});
var BigPointsWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__BigPointsWrapper",
  componentId: "sc-1i7dnbo-13"
})(["margin-top:", ";align-items:right;margin-left:0%;text-align:right;padding-left:45px;"], function (_ref46) {
  var theme = _ref46.theme;
  return theme.space.tiny;
});
var DiscountWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__DiscountWrapper",
  componentId: "sc-1i7dnbo-14"
})(["display:flex;flex-direction:'row';"]);
var DiscountPercentWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__DiscountPercentWrapper",
  componentId: "sc-1i7dnbo-15"
})(["display:flex;margin-left:10px;"]);
var BogoTagWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__BogoTagWrapper",
  componentId: "sc-1i7dnbo-16"
})(["background-color:#c82828;color:white;display:inline-block;padding:3px 4px;position:relative;top:-3px;font-size:12px;border-radius:4px;"]);
var ComboTagWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ComboTagWrapper",
  componentId: "sc-1i7dnbo-17"
})(["background-color:", ";color:white;display:inline-block;padding:3px 4px;position:relative;top:-3px;font-size:12px;border-radius:4px;"], function (_ref47) {
  var theme = _ref47.theme;
  return theme.colors.tertiary;
});
var PromoContainer = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PromoContainer",
  componentId: "sc-1i7dnbo-18"
})(["display:flex;background-color:#ad1c29 !important;border-radius:4px;padding-top:4px;padding-bottom:4px;padding-left:2px !important;padding-right:5px !important;align-items:center;justify-content:center;color:white;position:relative;top:-5px;"]);
var ToolTipContent = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ToolTipContent",
  componentId: "sc-1i7dnbo-19"
})(["display:flex;flex-flow:column wrap;text-align:left;"]);
var ContainerHeader = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ContainerHeader",
  componentId: "sc-1i7dnbo-20"
})(["display:flex;justify-content:end;"]);
var FixedWidthButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "PriceInfo__FixedWidthButton",
  componentId: "sc-1i7dnbo-21"
})(["width:90%;max-width:120px;@media (max-width:768px){width:90%;}"]);
var InstallmentInfo = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__InstallmentInfo",
  componentId: "sc-1i7dnbo-22"
})(["font-style:normal;font-weight:400;font-size:12px;line-height:", ";text-align:right;color:#2c2b2f;mix-blend-mode:normal;margin-bottom:4px;"], function (_ref48) {
  var theme = _ref48.theme;
  return theme.lineHeight.XXSmall;
});
var ORInfo = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ORInfo",
  componentId: "sc-1i7dnbo-23"
})(["font-style:normal;font-weight:400;font-size:12px;line-height:", ";text-align:right;color:#6e6d71;margin-bottom:4px;mix-blend-mode:normal;"], function (_ref49) {
  var theme = _ref49.theme;
  return theme.lineHeight.XXSmall;
});
var PriceInfo = function PriceInfo(_ref50) {
  var theme = _ref50.theme,
    isMobile = _ref50.isMobile,
    discountText = _ref50.discountText,
    enableCombosavingsTag = _ref50.enableCombosavingsTag,
    bundleSavingsTag = _ref50.bundleSavingsTag,
    totalSummaryPax = _ref50.totalSummaryPax,
    _ref50$strikeThrough = _ref50.strikeThrough,
    strikeThrough = _ref50$strikeThrough === void 0 ? {} : _ref50$strikeThrough,
    _ref50$strikethroughP = _ref50.strikethroughPrice,
    strikethroughPrice = _ref50$strikethroughP === void 0 ? {} : _ref50$strikethroughP,
    _ref50$price = _ref50.price,
    price = _ref50$price === void 0 ? {} : _ref50$price,
    _ref50$totalPrice = _ref50.totalPrice,
    totalPrice = _ref50$totalPrice === void 0 ? {} : _ref50$totalPrice,
    _ref50$perPersonBaseR = _ref50.perPersonBaseRate,
    perPersonBaseRate = _ref50$perPersonBaseR === void 0 ? {} : _ref50$perPersonBaseR,
    CTAButtonText = _ref50.CTAButtonText,
    perGuestText = _ref50.perGuestText,
    snapPriceText = _ref50.snapPriceText,
    onSelectRateHandler = _ref50.onSelectRateHandler,
    locale = _ref50.locale,
    _ref50$bigPoint = _ref50.bigPoint,
    bigPoint = _ref50$bigPoint === void 0 ? {} : _ref50$bigPoint,
    includedInPriceHeader = _ref50.includedInPriceHeader,
    perNight = _ref50.perNight,
    perGuest = _ref50.perGuest,
    isSnap = _ref50.isSnap,
    isSoldOut = _ref50.isSoldOut,
    isBogoPromoEnabled = _ref50.isBogoPromoEnabled,
    bogoTag = _ref50.bogoTag,
    move = _ref50.move,
    _ref50$isRM9PromoEnab = _ref50.isRM9PromoEnabled,
    isRM9PromoEnabled = _ref50$isRM9PromoEnab === void 0 ? true : _ref50$isRM9PromoEnab,
    accessible = _ref50.accessible,
    getTranslatedPricebreakdownData = _ref50.getTranslatedPricebreakdownData,
    secondNight = _ref50.secondNight,
    savingsAmount = _ref50.savingsAmount,
    totalInclusivePriceValue = _ref50.totalInclusivePriceValue,
    totalInclusivePriceCurrency = _ref50.totalInclusivePriceCurrency,
    installmentPaymentData = _ref50.installmentPaymentData,
    orText = _ref50.orText,
    enableInstallmentOption = _ref50.enableInstallmentOption;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var borderColor;
  var textColor;
  var hoverColor;
  var hoverBackgroundColor;
  if (isSoldOut) {
    borderColor = '#f8f8f8';
    textColor = '#c5c9d0';
    hoverColor = 'none';
    hoverBackgroundColor = 'none';
  } else {
    borderColor = move ? 'secondary' : 'primary';
    textColor = move ? 'secondary' : 'primary';
    hoverColor = move ? 'secondary' : 'default';
    hoverBackgroundColor = move ? 'secondaryLight' : 'primary';
  }
  var bundleSavingsText = "".concat(bundleSavingsTag, " ").concat((0, _Utils.localeCurrencyFormat)(strikeThrough === null || strikeThrough === void 0 ? void 0 : strikeThrough.currency, savingsAmount, 'code', locale, true, null, false, false));
  var _useState = (0, _react.useState)({
      top: 0,
      left: 0,
      height: 0
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    popoverPosition = _useState2[0],
    setPopoverPosition = _useState2[1];
  var promoContainerRef = (0, _react.useRef)(null);
  var calculatePopoverPosition = function calculatePopoverPosition() {
    if (promoContainerRef.current) {
      var rect = promoContainerRef.current.getBoundingClientRect();
      setPopoverPosition({
        top: rect.top,
        left: rect.left + rect.width / 2,
        height: rect.height
      });
    }
  };
  var handleMouseEnterCalled = function handleMouseEnterCalled() {
    calculatePopoverPosition();
  };
  (0, _react.useEffect)(function () {
    calculatePopoverPosition(); // Calculate position on mount
    window.addEventListener('resize', calculatePopoverPosition); // Recalculate on window resize
    return function () {
      window.removeEventListener('resize', calculatePopoverPosition); // Clean up event listener
    };
  }, []);
  var getToolTipContent = function getToolTipContent() {
    return /*#__PURE__*/_react.default.createElement(ToolTipContent, null, /*#__PURE__*/_react.default.createElement(_PriceBreakDown.default, (0, _extends2.default)({}, getTranslatedPricebreakdownData(secondNight), {
      theme: theme
    })));
  };
  var parts = totalSummaryPax === null || totalSummaryPax === void 0 ? void 0 : totalSummaryPax.split(' & ');
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(PriceWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(PriceDetails, {
      isMobile: isMobile
    }, isBogoPromoEnabled && bogoTag && (!isRM9PromoEnabled ? /*#__PURE__*/_react.default.createElement(BogoTagWrapper, null, bogoTag) : !isMobile && /*#__PURE__*/_react.default.createElement(ContainerHeader, null, /*#__PURE__*/_react.default.createElement(_Popover.default, {
      theme: theme,
      accessible: accessible,
      asToolTip: true,
      content: getToolTipContent(),
      position: _constants.CONTENT_POSITION.CUSTOM,
      trigger: isMobile ? _constants.TRIGGERS.click : _constants.TRIGGERS.hover,
      width: 360,
      customProperties: {
        position: 'absolute',
        left: "".concat(popoverPosition.height < 30 ? '97%' : '60%'),
        height: "".concat(popoverPosition.height < 30 ? popoverPosition.height - 13 : popoverPosition.height + 13, "px")
      }
    }, /*#__PURE__*/_react.default.createElement(PromoContainer, {
      ref: promoContainerRef,
      onMouseEnter: function onMouseEnter() {
        return handleMouseEnterCalled();
      }
    }, /*#__PURE__*/_react.default.createElement(_Label.default, null, bogoTag), /*#__PURE__*/_react.default.createElement(_BogoInfoIcon.default, null))))), bundleSavingsText && !isMobile && enableCombosavingsTag && isSnap && savingsAmount && /*#__PURE__*/_react.default.createElement(ComboTagWrapper, null, bundleSavingsText), /*#__PURE__*/_react.default.createElement(DiscountWrapper, {
      isMobile: isMobile
    }, (strikeThrough === null || strikeThrough === void 0 ? void 0 : strikeThrough.value) && !isMobile && /*#__PURE__*/_react.default.createElement(StrikeThrough, {
      isMobile: isMobile
    }, " ".concat((0, _Utils.localeCurrencyFormat)(strikeThrough === null || strikeThrough === void 0 ? void 0 : strikeThrough.currency, enableCombosavingsTag ? strikethroughPrice === null || strikethroughPrice === void 0 ? void 0 : strikethroughPrice.value : strikeThrough === null || strikeThrough === void 0 ? void 0 : strikeThrough.value, 'code', locale, true, null, false, false))), discountText && !isMobile && !enableCombosavingsTag && /*#__PURE__*/_react.default.createElement(DiscountPercentWrapper, null, /*#__PURE__*/_react.default.createElement(DiscountPercent, {
      isMobile: isMobile
    }, discountText))), perGuestText && /*#__PURE__*/_react.default.createElement(GuestInfo, null, perGuestText), (perPersonBaseRate === null || perPersonBaseRate === void 0 ? void 0 : perPersonBaseRate.value) && !isMobile && isSnap && !enableCombosavingsTag && /*#__PURE__*/_react.default.createElement(BasePriceWrapper, null, /*#__PURE__*/_react.default.createElement(BaseValue, null, " ".concat((0, _Utils.localeCurrencyFormat)(perPersonBaseRate.currency, perPersonBaseRate.value, 'code', locale, true, null, false, false)), '     '), "/", perGuest), (price === null || price === void 0 ? void 0 : price.value) && !isMobile && !isSnap && /*#__PURE__*/_react.default.createElement(BasePriceWrapper, null, /*#__PURE__*/_react.default.createElement(BaseValue, null, " ".concat((0, _Utils.localeCurrencyFormat)(price.currency, price.value, 'code', locale, true, null, false, false)), '     '), "/", perNight), enableCombosavingsTag && isSnap && !isMobile && /*#__PURE__*/_react.default.createElement(_Price.default, {
      amount: totalInclusivePriceValue,
      currency: totalInclusivePriceCurrency,
      allowLocaleFormat: true,
      locale: locale,
      noDecimalValues: true,
      defaultIDRLocale: false,
      customProperties: {
        marginRight: '-8px'
      }
    }), !enableCombosavingsTag && /*#__PURE__*/_react.default.createElement(TotalPrice, null, /*#__PURE__*/_react.default.createElement(PriceMobile, null, discountText && isMobile && !isBogoPromoEnabled && /*#__PURE__*/_react.default.createElement(DiscountPercent, {
      isMobile: isMobile
    }, discountText), (strikeThrough === null || strikeThrough === void 0 ? void 0 : strikeThrough.value) && isMobile && /*#__PURE__*/_react.default.createElement(StrikeThrough, {
      isMobile: isMobile,
      isBogoPromoEnabled: isBogoPromoEnabled
    }, " ".concat((0, _Utils.localeCurrencyFormat)(strikeThrough.currency, strikeThrough.value, 'code', locale, true, null, false, false)))), isMobile && (price === null || price === void 0 ? void 0 : price.value) && !isSnap && /*#__PURE__*/_react.default.createElement(BasePriceWrapper, null, /*#__PURE__*/_react.default.createElement(BaseValue, null, " ".concat((0, _Utils.localeCurrencyFormat)(price.currency, price.value, 'code', locale, true, null, false, false)), '     '), "/", perNight), isMobile && (perPersonBaseRate === null || perPersonBaseRate === void 0 ? void 0 : perPersonBaseRate.value) && isSnap && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(BasePriceWrapper, null, /*#__PURE__*/_react.default.createElement(BaseValue, null, " ".concat((0, _Utils.localeCurrencyFormat)(perPersonBaseRate.currency, perPersonBaseRate.value, 'code', locale, true, null, false, false)), '     '), "/", perGuest)), (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.value) !== price.value && /*#__PURE__*/_react.default.createElement(TotalValue, null, totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.text, " ".concat((0, _Utils.localeCurrencyFormat)(totalPrice.currency, totalPrice.value, 'code', locale, true, null, false, false)), '     ')), enableInstallmentOption && !!installmentPaymentData && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, orText && /*#__PURE__*/_react.default.createElement(ORInfo, null, orText), installmentPaymentData && /*#__PURE__*/_react.default.createElement(InstallmentInfo, null, installmentPaymentData)), totalSummaryPax && isSnap && enableCombosavingsTag && !isMobile && /*#__PURE__*/_react.default.createElement(ParentContainer, null, /*#__PURE__*/_react.default.createElement(SummaryPaxWrapper, null, /*#__PURE__*/_react.default.createElement("span", null, parts[0]), /*#__PURE__*/_react.default.createElement("br", null), parts[1] && /*#__PURE__*/_react.default.createElement("span", null, "& ", parts[1]))), snapPriceText && !enableCombosavingsTag && /*#__PURE__*/_react.default.createElement(Includes, null, snapPriceText), !isMobile && /*#__PURE__*/_react.default.createElement(FixedWidthButton, {
      border: borderColor,
      color: textColor,
      hoverColor: hoverColor,
      hoverBackgroundColor: hoverBackgroundColor,
      boxShadow: !isSoldOut,
      paddingLeft: "0px",
      paddingRight: "0px",
      handleClick: isSoldOut ? function () {} : onSelectRateHandler,
      fontWeight: "medium",
      disabled: isSoldOut
    }, CTAButtonText), !isMobile && (bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.template) && /*#__PURE__*/_react.default.createElement(BigPointsWrapper, null, /*#__PURE__*/_react.default.createElement(_BigPointToBeEarned.default, {
      template: bigPoint.template,
      pointTemplate: bigPoint.pointTemplate,
      pointValue: bigPoint.pointValue,
      multiplierTemplate: bigPoint.multiplierTemplate,
      multiplierValue: bigPoint.multiplierValue,
      customProperties: bigPoint.customProperties,
      includedInPriceHeader: includedInPriceHeader
    }))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
PriceInfo.propTypes = _RoomCard.PriceInfoPropTypes;
PriceInfo.defaultProps = _RoomCard.PriceInfoDefaultValues;
var _default = PriceInfo;
exports.default = _default;